import { render } from "./ViewerContainer.vue?vue&type=template&id=7d79504c&scoped=true&ts=true"
import script from "./ViewerContainer.vue?vue&type=script&lang=ts"
export * from "./ViewerContainer.vue?vue&type=script&lang=ts"

import "./ViewerContainer.vue?vue&type=style&index=0&id=7d79504c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d79504c"]])

export default __exports__